<template>
  <div class="care-list">
    <div class="header-layout">
      <img class="avatar" :src="user.avatar" />
      <div class="user-info">
        <div class="username">{{ safeMobile(user.name) || safeMobile(user.phone) }}</div>
        <div class="care-total-info" v-if="cares.length > 0">
          {{ cares.length + "张无忧卡" }}
        </div>
      </div>
       <div class="more-options">
         <span class="scan-code-img"><img v-if="isWechat" src="../../assets/ic_scan.png" @click="scanCareCardCode"></span>
         <span><img src="../../assets/care-setting-ico.png" @click="goto('/care/setting/index')"></span>
      </div>
    </div>
    <div class="header-bg-layout">
      <div class="view-about" @click="goto('/care/about')"></div>
      <div class="add-card" @click="goto('/care/add')"></div>
    </div>
    <div class="h-box">
      <template v-if="cares && cares.length > 0">
        <div class="cards" v-if="cares && cares.length > 0">
          <care-card
                  class="card"
                  v-for="care in cares"
                  :key="care.id"
                  :care="care"
                  :onClick="gotoDetail"
          />
        </div>
      </template>
      <template v-else>
        <div class="empty">
          <div class="ico"><img src="@/assets/card-add-home.png" /></div>
          <h3>暂无无忧卡</h3>
          <p>您可以点击上方添加无忧卡</p>
          <p>按钮或<span class="zxkf" @click="goto('KF_SERVICE')">咨询客服</span></p>
        </div>
      </template>
    </div>
    <activate-care-dialog
      v-model="showActivateCareDialog"
      :test="showActivateCareDialog"
      v-on:callback="activateCareDialogCallback"
    />
    <component v-if="currentTipsMessage" v-bind:is="useAlert" 
        v-model="showTips"
        :title="currentTipsMessage.title"
        :subTitle="currentTipsMessage.subTitle"
        :icon="currentTipsMessage.icon"
        :content="currentTipsMessage.message"
        :buttonText="currentTipsMessage.okText"
        @buttonClick="tipsDone"
        @closeClick="executeTips"
    ></component>
    <van-dialog class="new-year-dialog" v-model="holiday" confirm-button-text=" ">
      <div class="con">
        <div class="title"><span>2月13日-2月23日放假</span></div>
        <div class="sub-title">
          放假期间暂停所有履约服务
        </div>
        <div class="title"><span>2月24日（正月初八）</span></div>
        <div class="sub-title">
          恢复正常
        </div>
        <div class="notice">
          若用户在放假期间，无忧卡到期失效且有履约需求的，可在2月24日恢复服务后拨打4000889898客服电话继续申请履约。
          <br/>给您带来的不便，敬请理解！
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { login } from "../../scripts/auth";
import { httpOpen } from "../../scripts/network";
// const { publicPath } = process.env.CONFIG;
// const projectUrl = window.location.origin + publicPath;

const YActAlert = (resolve) =>
  require(["../../components/YActAlertDialog.vue"], resolve); // 领取无忧使用的提示窗

const NormalAlert = (resolve) =>
  require(["../../components/NormalAlert.vue"], resolve); // 续费和过期使用的提示窗

export default {
  name: "MyCare",
    computed:{
      safeMobile(){
          return function (val) {
              if(val && !isNaN(val) && val.length == 11){
                  return `${val.substring(0,3)}****${val.substring(7)}`
              }else{
                  return `${val.substring(0,1)}${val.substring(1).replace(/./g,"*")}`
              }
          }
      }
    },
  data() {
    return {
      isWechat: this.$store.state.isWechat,
      user: {
        name: "",
        phone: "",
        avatar: require("../../assets/ic_default_avatar.png"),
      },
      cares: [],
      showActivateCareDialog: false,
      tips: [], // 需要弹窗提醒消息数组
      currentTipsIndex: 0, // 当前提醒消息索引 
      currentTipsMessage: null, // 当前提醒消息
      showTips: true, 
      useAlert: null,
        holiday: false
    };
  },
  created() {
	   let islogin= this.initUserInfo();
	   if(islogin)
	   {
			   this.loadMyCare();
	   }
    //判断时间范围，显示春节放假弹窗
      let currDate = new Date().toGMTString();
      if (new Date(currDate) >=
          new Date("2026/02/12 18:00:00+08:00") && new Date(currDate) <=
          new Date("2026/02/24 00:00:00+08:00")){
            this.holiday = true
      }
  },
  methods: {
    initUserInfo() {
      const info = this.$store.state.userInfo;
      if (!info) {
        // login(this.$store, this.$router);
		this.$router.push({ path: '/care/anonymous' });
        return false;
      }
      this.user = {
        avatar: info.avatar || require("../../assets/ic_default_avatar.png"),
        name: info.name || "",
        phone: info.phone || "",
      };
	  return true;
    },
    async loadMyCare() {
      this.$loading.show("正在加载...");
      try {
        const ret = await httpOpen("/WuYouCard/GetUserCardList", {
          type: "post",
          body: { CustomerMobilePhone: this.user.phone },
        });
        if (!ret.Status && parseInt(ret.ErrorCode) === 401) {
          login(this.$store, this.$router);
          return;
        } else if (!ret.Status) {
          this.$toast("加载失败，请稍后重试");
        } else {
          this.cares = ret.Data.map(this.resultMapper);

          if (!this.cares || this.cares.length == 0) return;

          let cards = this.cares.filter((c) => c.renewCard && c.status != -20); // 弹窗提醒指针对可续费卡(体验卡)
          // 保证弹框的顺序
          await this.setActiveCard(cards);
          await this.setRenewCard(cards);
          await this.setExpiredCard(cards);
          this.executeTips();
        }

        console.log(ret);
      } catch (e) {
        console.error(e);
      } finally {
        this.$loading.hide();
      }
    },
    resultMapper(data) {
      const supportnew = 1; // 是否支持续费
      return {
        id: data.sysNo,
        type: data.ServiceType,
        endTime: data.FailureTime && new Date(data.FailureTime + "+08:00"),
        imei: data.IMEICode,
        status: data.CardStatus,
        audit: data.AuditStatus,
        name: data.ServiceTypeName,
        single: !data.EquityVal || data.EquityVal.length <= 1,
        code : data.ActivationCode,
        effectiveDay: data.EffectiveDay,
        img: data.CardLogo,
        renewCard: data.IsSupportRenew == supportnew, // 可续费卡
        canRenew: data.IsSupportRenew == supportnew && data.CardStatus == 20, // 当前是否可以续费(卡已激活 && 可续费卡)
        surplus: data.FailureTime && new Date(data.FailureTime + "+08:00").diff(new Date()).day,// 有效天数(剩余过期天数)
      };
    },
    async setActiveCard(cards){ // 未激活卡提醒
      const LastActiveTipsDateStorageKey = 'active-tips-date';
      let today = new Date().format("yyyy-MM-dd");
      if(window.local.getValue(LastActiveTipsDateStorageKey) == today) return; // 今天已经提示

      let item;
      for (let i = 0; i < cards.length; i++) {
        let card = cards[i];
        if (card.status == 10 && card.audit != 10) {
          item = {
            card : card, 
            title : card.name,
            subTitle: null,
            icon: require('@/assets/ic_alert_expire.png'),
            message : '限时免费领取',
            okText: '我要领取',
            tipsType: 1,
            done: function() {
              window.local.saveValue(LastActiveTipsDateStorageKey, today);// 记录已经提示
            }
          };
          this.tips.push(item);
          return item;
        }
      }
    },
    async setRenewCard(cards){ // 需要续费的卡提醒(每天提醒一次)
      const LastRenewTipsDateStorageKey = 'renew-tips-date';
      let today = new Date().format("yyyy-MM-dd");
      if(window.local.getValue(LastRenewTipsDateStorageKey) == today) return; // 今天已经提示
      for (let i = 0; i < cards.length; i++) {
        let card = cards[i];
        if (card.status == 20) {
          let flag = await this.hasUsed(card.id);  //已使用过卡无需提醒
          if(!flag)
          {
            let item = {
              card: card, 
              title: '保护<br>即将到期',
              subTitle: '小主，真的要离开我了么？<br>好想一直保护你',
              icon: require('@/assets/ic_alert_expire.png'),
              message: card.name +'将于<span style="color:red">'+ (card.surplus || 0) +'</span>天后到期，到期后您的爱机不再享有手机碎屏保障',
              okText: '立即续费',
              tipsType: 2,
              done: function() {
                window.local.saveValue(LastRenewTipsDateStorageKey, today);// 记录已经提示
              }
            };
            this.tips.push(item);
            return item;
          }
        }
      }
    },
    async setExpiredCard(cards) { // 已过期卡提醒(提醒过的卡不再提醒)
      const ExpiredTipsItemsStorageKey = 'expired-tips-ids';
      let tipsItems = JSON.parse(window.local.getValue(ExpiredTipsItemsStorageKey)) || [];//已提醒过的过期卡ID
      for (let i = 0; i < cards.length; i++) {
        let card = cards[i];
        if (card.status == -10 && !tipsItems.find((d) => d == card.id)) {
          let flag = await this.hasUsed(card.id);  //已使用过卡无需提醒
          if(!flag) {
            let item = {
              card : card, 
              title : '过期提示',
              subTitle: '小主：',
              incon: '',
              message: card.name +' 已到期，您的爱机不再享有手机碎屏保障',
              okText: '我知道了',
              tipsType: 3,
              done: function() {
                let ids = JSON.parse(window.local.getValue(ExpiredTipsItemsStorageKey)) || [];//已提醒过的过期卡ID
                ids.push(card.id);
                window.local.saveValue(ExpiredTipsItemsStorageKey, JSON.stringify(ids));// 记录已经提示
              }
            };
            this.tips.push(item);
            return item;
          }
        }
      }
    },
    executeTips(){
      this.showTips = false;
      if(this.tips.length > this.currentTipsIndex) {
        setTimeout(() => {
          this.currentTipsMessage = this.tips[this.currentTipsIndex++];
          this.useAlert = this.currentTipsMessage.tipsType == 1 ? YActAlert : NormalAlert;
          this.showTips = true;
          if(this.currentTipsMessage.done){
            this.currentTipsMessage.done(); // 提示完成,记录已提示消息
          }
        }, 500);
      }
    },
    tipsDone() {
      let tipsType = this.currentTipsMessage.tipsType; // 提示类型
      let card = this.currentTipsMessage.card;
      switch(tipsType){
        case 1:
          this.$router.push({
            name: "CareActive",
            params: {
              code: card.code, // 无忧卡激活码
              type: card.type  // 卡类型
            },
            query:{
              name: card.name
            }});// 转向激活
          break;
        case 2:
          this.$router.push({
            name:"CareRenewPay",
            params: {
              id: card.id,
            },
            query: {
              type: card.type,
              name:card.name,
              time: card.endTime && card.endTime.getTime()
            }
          });
          break;
        case 3:
          console.log('tips done','已过期');
          break;
      }
    },
    async hasUsed(cardId){ // 查询是否有履约
      let used = false;
      try {
        const ret = await httpOpen("/WuYouCard/JudgeCardUseState", {
          type: "post",
          body: { CardSysNo: cardId },
        });
        used = ret.Status; // STATUS 表示是否已使用
        console.log(ret);
      } catch (e) {
        console.error(e);
      }
      return used;
    },
    async scanCareCardCode() {
      let res = await this.scanQRCode();
      const reg = /^[a-zA-Z]{6}[0-9]{6}$/;
      // const url = projectUrl + "/care/card/";
      if (res.indexOf("http://") === 0 || res.indexOf("https://") === 0) {
        this.goto(res);
      } else if (reg.test(res)) {
        // this.$toast("未识别该卡");
        this.goto("/care/card/" + res);
      } else {
        this.$toast("未识别该卡");
      }
    },
    gotoDetail(care) {
      //status: 10= 未激活，20=已激活，-10=已失效，-20=已作废
      //audit: -1=未提交审核，10=待审核，20=审核通过，30=审核失败
      if(care.status == -20)
      {
        this.$toast("该卡已作废");
        return; // 作废卡无法查看
      } 

      if(care.renewCard && (care.status == 20 || care.status == -10)) {
        this.gotoRenewDetail(care); // 已激活或已过期的续费卡转至续费卡详情页
      }else {
        this.$router.push("/care/" + care.id);
      }
    },
    gotoRenewDetail(card) {
      this.$router.push("/care/renew/" + card.id);
    },
    activateCareDialogCallback() {
      this.showActivateCareDialog = false;
    },
    activate() {
      this.showActivateCareDialog = true;
    },
    goAd() {
      this.goto("https://r.piseneasy.com/pro/page/114");
    },
  },
};
</script>
<style lang="less" scoped>
.care-list {
  background: #f4f4f4 url("~@/assets/care-head-bg.png") 0 0 no-repeat;
  background-size: 100%;
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 50px;
  button {
    width: 100%;
    text-align: center;
    color: white;
    font-size: 16px;
    line-height: 34px;
    height: 34px;
    border: none;
    margin: 16px 0;

    background: linear-gradient(
      86deg,
      rgba(224, 172, 119, 1) 0%,
      rgba(186, 136, 89, 1) 100%
    );
    border-radius: 17px;
  }

  button:active {
    background: linear-gradient(
      86deg,
      rgb(230, 165, 101) 0%,
      rgb(212, 114, 22) 100%
    );
  }
}
h4 {
  font-size: 16px;
  margin: 0;
}

.header-layout {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 40px 24px 16px 24px;
  .avatar {
    display: block;
    width: 58px;
    height: 58px;
    border-radius: 29px;
    box-sizing: border-box;
    border: 4px solid white;
    margin-right: 8px;
  }

  .user-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex: 1 1;
  }
  .username {
    color: black;
    font-weight: bold;
    font-size: 16px;
  }
  .care-total-info {
    font-size: 10px;
    color: #fbefd7;
    background: black;
    height: 20px;
    line-height: 20px;
    padding: 0 6px;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 4px;
  }

  .care-total-info::before {
    content: "";
    display: block;
    background: url("../../assets/ic_star.png") no-repeat top left;
    background-size: 15px 15px;
    width: 15px;
    height: 15px;
  }
}
.bottom-banner {
  width: 100%;
  height: auto;
  margin-top: 16px;
  img {
    margin-top: 8px;
    width: 100%;
    border-radius: 8px;
  }
}
.cards {
  padding: 8px 16px;
}

.card + .card {
  margin-top: 10px;
}

.h-box{
  background-color: #f4f4f4;
  min-height: 300px;
  padding-top: 10px;
  .empty{
    text-align: center;
    .ico{
      padding-top: 95px;
      >img{
        width: 66px;
        height: 48px;
      }
    }
    h3{
      font-size: 17px;
      font-weight: 600;
    }
    p{
      color: #333;
      font-size: 12px;
      margin: 0;
      .zxkf{
        color: #3B7CDC;
      }
    }
  }
}
.header-bg-layout {
  background: url("../../assets/head-bg-add.png") 0 10px no-repeat;
  height: 75px;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 10%;
  .view-about{
    flex: 1;
    height: 80%;
  }
  .add-card{
    flex: 1;
    height: 80%;
  }
}
.new-year-dialog{
  background: url("~@/assets/notice-new-year-bg.png") 0 0 no-repeat;
  background-size: 100% 100%;
  color: #875A01;
  overflow: initial;
  font-size: 14px;
  padding: 0 50px;
  box-sizing: border-box;
  border-radius: inherit;
  .con{
    padding: 80px 0 70px 0;
    line-height: 1.7;
    .title{
      margin-top: 20px;
      color: #82520f;
      font-size: 15px;
      font-weight: 600;
      >span{
        position: relative;
        &:before{
          position: absolute;
          content: '';
          background-color: #FFD683;
          top:50%;
          left: 0;
          right: -2px;
          bottom: 0;
          z-index: -1;
        }
      }
    }
    .sub-title{
      font-weight: 600;
    }
    .notice{
      margin-top: 9px;
    }
  }
}
.more-options{
  img{
    width: 23px;
    height: 24px;
  }
  .scan-code-img{
    margin-right: 17px;
  }
}
</style>
<style scoped>
  .new-year-dialog >>>.van-dialog__footer{
    position: absolute;
    left: 20%;
    right: 20%;
    bottom:-68px;
  }
  .new-year-dialog >>>.van-dialog__footer .van-button{
    background: url("~@/assets/notice-new-year-2.png") 50% 50% no-repeat;
    background-size: 80%;
  }
  .new-year-dialog >>>.van-dialog__footer .van-button:before{
    background-color: initial;
    border: none;
  }
  .new-year-dialog >>>.van-dialog__footer:after{
    background-color: initial;
    border: none;
  }
</style>
